export const updateClick = () => ({
  type: 'CLICKED',
});

export const setLocation = (location) => ({
  type: 'SET_LOCATION',
  location,
});

export const setUser = (user) => ({
  type: 'SET_USER',
  user,
});

export const updateUserWorkDays = (workDays) => ({
  type: 'UPDATE_WORKDAYS',
  workDays,
})
